import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as $ from 'jquery'
import 'datatables.net';
import 'datatables.net-bs4';
import { DataServiceService } from 'src/app/data-service.service';
import { NgxSpinnerService } from 'ngx-spinner';



@Component({
  selector: 'app-academic-students-table',
  templateUrl: './academic-students-table.component.html',
  styleUrls: ['./academic-students-table.component.scss']
})
export class AcademicStudentsTableComponent implements OnInit {
  @ViewChild('example') example!: ElementRef;
  @Output() tablebackData = new EventEmitter()

  @Input() stddata: any; // Assuming you have stddata as an Input property
  @Output() academicback = new EventEmitter<{ emitValue: boolean, studentData: any }>();

  Table_details: any;
  studentdetails: any;

  constructor(private dataService: DataServiceService, private spinner: NgxSpinnerService) { }
  ngOnInit(): void {
    this.academicdata()
  }



  pending(studentData: any) {
    this.academicback.emit({ emitValue: false, studentData });
  }

  submitted(studentData:any){
    this.academicback.emit({emitValue:false,studentData});
  }

  backToAcademic() {
    this.tablebackData.emit(false);
  }

  academicdata() {
    this.spinner.show()
    this.dataService.academicTableget().subscribe((res) => {
      this.Table_details = res;
      $(document).ready(() => {
        $('#studenttable').DataTable();
      });
      this.spinner.hide()
    });
  }

}


